<template>
  <el-container>
    <el-main style="padding:0;width:100vh">
      <vm-table
          ref="vmTable"
          height="62vh"
          :filter.sync="filter"
          module="basic"
          url="appUpdates">
        <div slot="toolbar">
          <el-button v-if="addAuth" type="primary" @click="$refs.editPage.open(0)">新建</el-button>
        </div>
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="查询">
              <el-input v-model.trim="filter.filter" clearable/>
            </vm-search>
          </div>
        </template>
        <el-table-column prop="name" align="center" label="名称"/>
        <el-table-column prop="version" align="center" label="版本号"/>
        <el-table-column label="操作" align="center" class-name="vm-table_operate">
          <template slot-scope="scope">
            <el-button v-if="deleteAuth" type="danger" @click="deleteRow(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </vm-table>
      <edit-page ref="editPage" @save-success="getList(1)"/>
    </el-main>
  </el-container>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import EditPage from "@/views/App/AppEdit";
  export default {
    name: "App",
    components: {EditPage,VmTable,VmSearch},
    data() {
      return {
        addAuth: this.$auth(52),
        deleteAuth: this.$auth(53),
        filter: {
          filter: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      deleteRow(row) {
        this.$http.delete("basic","appUpdates", row.pkid).then(() => {
          this.getList(-1);
          this.$message.success("删除成功");
        });
      },
    },
  };
</script>
<style scoped>
</style>
